import React from "react";

const Considerations = () => {
 return (
  <div className="const_bg">
   <h2 className="title_cons">
    Consideraciones para atender una situación de crisis emocional en el lugar
    de trabajo
   </h2>
   <ul>
    <li>
     <b>
      1. &nbsp; &nbsp; Prevención de crisis y acciones a favor del bienestar
      emocional de los colaboradores
     </b>
     <br />
     <br />➧ Revisión de las condiciones laborales y las causas administrativas
     que puedan contribuir a la crisis. En correspondencia dedicar reformas en
     la organización que promuevan el equilibrio ocupacional
    </li>
    <li>
     <b>2. &nbsp; &nbsp; Planteamiento de los Primeros Auxilios Psicológicos</b>
     <br />
     <br />➧ &nbsp; &nbsp; Concientizar al personal que los eventos de crisis
     emocional pueden suceder en cualquier momento. Y resaltar que atender con
     Primeros Auxilios Psicológicos puede prevenir el Trastorno de Estrés
     Postraumático que deriva a la postre en disminución del desempeño laboral
    </li>
    <li>
     <b>
      3. &nbsp; &nbsp; Preparación y entrenamiento de los Primeros Auxilios
      Psicológicos
     </b>
     <br />
     <br />
     ➧ &nbsp; &nbsp; Elección de un protocolo dedicado a las crisis
     psico-emocionales y asignación de equipos y/o roles
     <br />
     <br />
     ➧ &nbsp; &nbsp; Capacitación de las brigadas de respuesta
     <br />
     <br />➧ &nbsp; &nbsp; Al preparar el contexto para atender una crisis es
     recomendable asignar un espacio seguro y tranquilo en el que únicamente
     estén aquellas personas que cumplirán una función en el acompañamiento
    </li>
    <li>
     <b>
      4. &nbsp; &nbsp; Comunicar al personal que lugar de prioridad ocupa
      atender una crisis emocional
     </b>
    </li>
    <li>
     <b>
      5. &nbsp; &nbsp; Aplicar los pasos del modelo ABCDE de Primeros Auxilios
      Psicológicos
     </b>
    </li>
    <li>
     <b>6. &nbsp; &nbsp; Brindar seguridad psicológica</b>
     <br />
     <br />
     ➧ &nbsp; &nbsp; Brindar seguridad psicológica. La seguridad psicológica se
     puede definir como un entorno en el que las personas se sienten seguras de
     ser ellas mismas, de tomar decisiones, de no estar de acuerdo, ofrecer
     diferentes puntos de vista, cometer errores, admitir esos errores y
     experimentar con acciones no probadas
     <br />
     <br />➧ &nbsp; &nbsp; No se puede hablar de verdadera seguridad psicológica
     si no se acompañan con medidas administrativas conducentes. Un buen
     ejemplo, es el cumplimiento de la confidencialidad de la intervención. Otro
     caso es el de otorgar permisos, tales como; permisos de ausencia,
     vacaciones o la flexibilización de la jornada en caso de ser requeridos
     después de una crisis emocional
    </li>
    <li>
     <b>7. &nbsp; &nbsp; Auto-evaluación del proceso y seguimiento de casos</b>
     <br />
     <br />➧ &nbsp; &nbsp; Evaluar cómo se llevó a cabo el proceso, dar
     seguimiento a los casos por medio de valoraciones psicológicas, y aplicar
     mejoras constantes
    </li>
   </ul>
  </div>
 );
};

export default Considerations;
